import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateAgo'
})
export class DateAgoPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    if (value) {
      return moment(value).fromNow(true) + " ago";
    }
    return value;
  }

}
